import React, { useState, useEffect } from 'react'
import { Navigate, useLocation } from 'react-router-dom'

const SimpleProtectedRoute = ({ children, allowedRoles = [] }) => {
  const [user, setUser] = useState(null)
  const [loading, setLoading] = useState(true)
  const location = useLocation()

  useEffect(() => {
    // Simple check: just look at localStorage
    const checkAuth = () => {
      const storedUser = localStorage.getItem('user')
      if (storedUser) {
        try {
          const userData = JSON.parse(storedUser)
          setUser(userData)
        } catch (error) {
          console.error('Error parsing stored user:', error)
          localStorage.removeItem('user')
          setUser(null)
        }
      } else {
        setUser(null)
      }
      setLoading(false)
    }

    checkAuth()

    // Check every second to catch any changes
    const interval = setInterval(checkAuth, 1000)
    return () => clearInterval(interval)
  }, [])


  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="spinner"></div>
      </div>
    )
  }

  if (!user) {
    return <Navigate to="/auth/login" state={{ from: location }} replace />
  }

  // Check roles if specified
  if (allowedRoles.length > 0) {
    const userRole = user.role || user.user_metadata?.role || 'customer'
    const isRoleAllowed = allowedRoles.some(allowedRole => 
      allowedRole.toLowerCase() === userRole.toLowerCase()
    )
    
    if (!isRoleAllowed) {
      return <Navigate to="/" replace />
    }
  }

  return children
}

export default SimpleProtectedRoute
